import {
  InputCalendar,
  InputNumber,
  InputRadio,
  InputSelectSearch,
  InputText,
  InputTextarea,
} from '~/components/BaseForm/core/primitives'
import type { CoreGroupFields } from '~/components/BaseForm/types'

export default (): CoreGroupFields => {
  const whereToLeave: typeof InputRadio = {
    ...InputRadio,
    options: ['yes', 'no'].map((value) => ({
      labelTranslateKey: `global.${value}`,
      value,
    })),
    attr: {
      ...InputRadio.attr,
      labelTranslateKey: 'contact.form.knowWhereToLeave',
      name: 'knowWhereToLeave',
      rules: 'required',
      vertical: false,
    },
  }
  const destination: typeof InputSelectSearch = {
    ...InputSelectSearch,
    containerInputClass: 'w-full',
    attr: {
      ...InputSelectSearch.attr,
      canClear: true,
      mode: 'single',
      name: 'destination',
      labelTextTranslateKey: 'contact.form.destination',
      placeholderTranslateKey: 'search.placeholder',
      resolveOnLoad: true,
      rules: 'required',
      searchable: true,
    },
  }
  const dates: typeof InputCalendar = {
    ...InputCalendar,
    containerInputClass: 'w-full sm:w-[48%]',
    attr: {
      ...InputCalendar.attr,
      labelTranslateKey: 'global.travel_dates',
      name: 'dates',
    },
  }
  const budget: typeof InputText = {
    ...InputText,
    containerInputClass: 'w-full sm:w-[48%]',
    attr: {
      ...InputText.attr,
      labelTranslateKey: 'field.budget',
      name: 'budget',
      min: 0,
      type: 'number',
    },
  }
  const guests: typeof InputNumber = {
    ...InputNumber,
    containerInputClass: 'w-1/2',
    attr: {
      ...InputNumber.attr,
      labelTranslateKey: 'field.guests',
      min: 0,
      name: 'guests',
    },
  }

  const message: typeof InputTextarea = {
    ...InputTextarea,
    attr: {
      ...InputTextarea.attr,
      labelTranslateKey: 'contact.form.yourRequest',
      placeholderTranslateKey: 'contact.form.yourRequestPlaceholder',
      rules: 'required',
      rows: 4,
      name: 'message',
    },
    containerInputClass: 'w-full',
  }

  return {
    containerGroupFieldsClass: 'w-full flex flex-wrap justify-between gap-2',
    key: 'inquiry',
    fields: [whereToLeave, destination, dates, budget, guests, message],
  }
}
